import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

const SliderRootSlot = prepareForSlot(function SliderRoot(
  props: ComponentProps<'span'>,
): JSX.Element {
  const { children, className, ...rest } = props

  return (
    <span className={clsx('slider-root', className)} {...rest}>
      <span className="slider-root__container">{children}</span>
    </span>
  )
})

export const SliderRoot = SliderRootSlot
